import type { Theme } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface LayoutComponentStyles {
  appActionsRow: AppSx;
  appFormFieldInner: AppSx;
  appFormFieldInnerStretch: AppSx;
  pageDataTablePanel: (borderColor: string, backgroundColor: string) => AppSx;
  pageListPlainOuter: AppSx;
  pageListPanelPaper: AppSx;
  pageListStack: AppSx;
  pageHeaderSubtitle: AppSx;
  pageHeaderActions: AppSx;
}

export function buildLayoutComponentStyles(_theme: Theme): LayoutComponentStyles {
  return {
    appActionsRow: { mt: 0.5 },
    appFormFieldInner: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-end",
    },
    appFormFieldInnerStretch: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
    },
    pageDataTablePanel: (borderColor, backgroundColor) => ({
      border: `1px solid ${borderColor}`,
      borderRadius: 1.25,
      overflow: "hidden",
      bgcolor: backgroundColor,
      pb: 1.5,
    }),
    pageListPlainOuter: { width: 1 },
    pageListPanelPaper: { bgcolor: "background.paper", borderColor: "divider" },
    pageListStack: {
      width: 1,
      display: "flex",
      flexDirection: "column",
      gap: 1.25,
      minWidth: 0,
    },
    pageHeaderSubtitle: { mt: 0.25 },
    pageHeaderActions: {
      display: "flex",
      alignItems: "center",
      gap: 1.25,
      flexWrap: "wrap",
      justifyContent: { xs: "flex-start", sm: "flex-end" },
      flexShrink: 0,
      // Page CTAs (New widget / adaptor / …) — ~25% smaller than the prior oversized scale.
      "& .MuiButton-root": {
        minHeight: 33,
        px: 1.875,
        py: 0.85,
        fontSize: "0.8rem",
        fontWeight: 700,
        lineHeight: 1.25,
      },
      "& .MuiButton-startIcon": {
        marginLeft: "-2px",
        marginRight: "8px",
        "& > *:nth-of-type(1)": {
          fontSize: "1.05rem",
        },
        "& .MuiSvgIcon-root, & .material-icons, & .material-icons-round": {
          fontSize: "1.05rem !important",
        },
      },
      "& .MuiButton-endIcon": {
        marginLeft: "8px",
        "& .MuiSvgIcon-root, & .material-icons, & .material-icons-round": {
          fontSize: "1.05rem !important",
        },
      },
    },
  };
}
